/* eslint-disable no-underscore-dangle */
import { isModelType as mstIsModelType, isArrayType, isReferenceType as mstIsReferenceType, isUnionType, isStateTreeNode as mstIsStateTreeNode, getRoot, getType } from 'mobx-state-tree';
export function isIdentifierReferenceType(mstNodeType) {
    return mstIsReferenceType(mstNodeType);
}
export function isIdentifierReferenceTypeArray(mstNodeType) {
    if (isUnionType(mstNodeType)) {
        if (!mstNodeType._types) {
            return false;
        }
        var firstTypeOfUnion = mstNodeType._types[0];
        return isArrayType(firstTypeOfUnion) && isIdentifierReferenceType(firstTypeOfUnion._subType);
    }
    return isArrayType(mstNodeType) && isIdentifierReferenceType(mstNodeType._subtype._subType);
}
export function isModelType(mstNodeType) {
    return mstIsModelType(mstNodeType);
}
export function isModelTypeArray(mstNodeType) {
    if (isUnionType(mstNodeType)) {
        if (!mstNodeType._types) {
            return false;
        }
        var firstTypeOfUnion = mstNodeType._types[0];
        return isArrayType(firstTypeOfUnion) && isModelType(firstTypeOfUnion._subType);
    }
    return isArrayType(mstNodeType) && isModelType(mstNodeType._subtype._subType);
}
export function isStateTreeNode(value) {
    return mstIsStateTreeNode(value);
}
export function getRootStore(store) {
    return getRoot(store);
}
export function findStoreOfTypeInTree(rootStore, type) {
    // get all state tree node properties of rootStore
    var stateTreeNodeProperties = Object.values(rootStore).filter(function (propertyValue) { return isStateTreeNode(propertyValue); });
    // first flat scan all state tree node properties
    var storeOfModelType = stateTreeNodeProperties.find(function (stateTreeNodeProperty) { return stateTreeNodeProperty.modelType === type; });
    // if the store of the type was found ==> return it
    if (storeOfModelType) {
        return storeOfModelType;
    }
    // deep scan the state tree nodes, if one of them contains the searched store
    return stateTreeNodeProperties.find(function (x) { return findStoreOfTypeInTree(x, type); });
}
export function findAllTypesInTree(treeNode, rootStore, results) {
    if (results === void 0) { results = []; }
    if (!rootStore) {
        var rootStoreInstance = getRootStore(treeNode) || treeNode;
        rootStore = getType(rootStoreInstance);
    }
    // get all state tree node properties of rootStore
    var stateTreeNodeProperties = Object.values(rootStore.properties).filter(function (propertyValue) { return isModelType(propertyValue); });
    stateTreeNodeProperties.forEach(function (stateTreeNodeProperty) {
        var type = stateTreeNodeProperty;
        if (results.includes(type)) {
            return;
        }
        results.push(type);
        results.push(findAllTypesInTree(treeNode, stateTreeNodeProperty, results));
    });
    return results;
}
export function replaceArray(arrayInTree, replaceTree) {
    var newItems = replaceTree.filter(function (x) { return !arrayInTree.includes(x); });
    var removedItems = arrayInTree.filter(function (x) { return !replaceTree.includes(x); });
    newItems.forEach(function (x) { return arrayInTree.push(x); });
    removedItems.forEach(function (x) { return arrayInTree.remove(x); });
}
//# sourceMappingURL=MobxStateTreeHelpers.js.map